#import "../fragments/stageset-context-fragment.graphql"
#import "../fragments/lead-context-fragment.graphql"

query GetPageContext($id: ID!) {
    pageTheUserIsCurrentlyLookingAt: contextEntity(id: $id) {
        ... on Stageset {
            ...StagesetContext
        }
        ... on Lead {
            ...LeadContext
        }
    }
}
